import { render, staticRenderFns } from "./TicketsData.vue?vue&type=template&id=08960516&"
import script from "./TicketsData.vue?vue&type=script&lang=js&"
export * from "./TicketsData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08960516')) {
      api.createRecord('08960516', component.options)
    } else {
      api.reload('08960516', component.options)
    }
    module.hot.accept("./TicketsData.vue?vue&type=template&id=08960516&", function () {
      api.rerender('08960516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/TicketsData.vue"
export default component.exports